import React from 'react';
import Breadcrumbs from '../../sections/Breadcrumbs';

const HowToGetInvolved: React.FC = () => (
  <div className="max-w-4xl mx-auto py-12 px-4">
    <Breadcrumbs items={[
      { label: 'Home', href: '/' },
      { label: 'About', href: '/about' },
      { label: 'How to Get Involved' }
    ]} />
    <h1 className="text-3xl font-bold mb-4">How to Get Involved</h1>
    <p>This is a placeholder for the How to Get Involved page.</p>
  </div>
);

export default HowToGetInvolved; 